// extracted by mini-css-extract-plugin
export var btn = "Q_mB q_rK q_rp d_bz d_bP d_bD d_dw";
export var full = "Q_wN d_w d_H";
export var hoverStyle = "Q_mF";
export var zoom = "Q_mG";